// A view of another module loaded when it is first shown (ADR 0064 step B): a module's front door offers its bigger
// views this way, so a page that names one does not carry it until it renders.
import * as React from 'react';

export function lazyView<P extends object>(
  load: () => Promise<React.ComponentType<P>>,
): React.ComponentType<P> {
  const Lazy = React.lazy(async () => ({ default: await load() }));
  const View = (props: P) => (
    <React.Suspense fallback={null}>
      <Lazy {...props} />
    </React.Suspense>
  );
  return View;
}
